import { SubNavContainer } from '@/components/sub-nav-container';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useAnalytics } from '@/hooks/useAnalytics';

export const Route = createFileRoute('/contact-us/')({
  component: RouteComponent,
  context: () => {
    return {
      getBreadcrumbData: () => ({
        id: null,
        translationKey: null,
      }),
    };
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Contact Us - OPAZ E-Service Portal',
        },
      ],
    };
  },
});

function RouteComponent() {
  const { t } = useTranslation();
  const analytics = useAnalytics();

  const handleContactClick = (contactType: string) => {
    if (!analytics) return;

    // Track contact method usage
    analytics.trackNavigationClick(`Contact: ${contactType}`);
  };

  return (
    <>
      <SubNavContainer showOneStepBreadcrumbs>
        <div className="max-w-container-960">
          <h1 className="text-3xl font-bold text-foreground">{t('contact.title')}</h1>
          <p className="text-xl font-normal text-foreground pt-5 pb-8">{t('contact.subtitle')}</p>
        </div>
      </SubNavContainer>

      <main className="max-w-container-960 mx-auto pt-8 pb-20 px-4 lg:px-0">
        <div className="space-y-4">
          <h2 className="text-xl font-bold text-foreground">{t('contact.contactInfo')}</h2>

          <div>
            <h3 className="text-base font-bold text-foreground">{t('contact.email.title')}</h3>
            <p className="text-base font-normal text-foreground">
              <a
                href="mailto:call.center@opaz.gov.om"
                onClick={() => handleContactClick('email')}
                className="text-link underline hover:opacity-80"
              >
                call.center@opaz.gov.om
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-base font-bold text-foreground">{t('contact.callCenter.title')}</h3>
            <p className="text-base font-normal text-foreground">
              <a
                href="tel:1919"
                onClick={() => handleContactClick('phone')}
                className="text-link underline hover:opacity-80"
              >
                1919
              </a>
            </p>
          </div>

          <div>
            <h3 className="text-base font-bold text-foreground">{t('contact.international.title')}</h3>
            <p className="text-base font-normal text-foreground">
              <a
                href="tel:+96880011110"
                onClick={() => handleContactClick('international_phone')}
                className="text-link underline hover:opacity-80"
              >
                <span dir="ltr">+968 80011110</span>
              </a>
            </p>
          </div>
        </div>
      </main>
    </>
  );
}
